/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
/* eslint-disable consistent-return */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useCallback } from 'react';
import { withRouter } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import Box from '@mui/material/Box';
import { default as MuiTab } from '@material-ui/core/Tab';
import { withStyles } from '@material-ui/core/styles';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import DefaultAudit from './defaultAudits';
import DefaultUnitType from './defaultUnitTypeAudit/defaultUnitTypeAudit';
import GeneralSystemParameters from './generalSystemParameters';
import DefaultSystemParameters from './defaultSystemParameters';
import Holiday from './holiday/holiday';
import MDspecteracode from './mdspecthera/mdSpecterCode';
import NMFineCode from './NMFinceCode/nmFineCode';
import NMAccountNumber from './nmaccountnumber/nmAccountNumber';
import DisplaySuccessMessages from '../../../../SharedModules/Errors/SuccessMessage';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  FAILED_MESSAGE_GENERIC,
  MAX_THRESHOLD_ALLOWED,
  MAX_RETAINED_QTR,
  PERCENT_AVERAGE_UNITS_REQ,
  PERCENT_SUBMITTED_AMOUNT_REQ,
  PERCENT_ALLOWED_AMOUNT_REQ,
  THRESHOLD_AMOUNT_REQ,
  PERCENT_PRIOR_QUARTER_REQ,
  PERCENT_REIMBURSED_AMOUNT_REQ,
  QUARTER_FORMAT_ERROR,
  END_QTR_ERROR,
  START_QTR_UC,
  HOLIDAY_DATE_REQUIRED,
  HOLIDAY_DESC_REQ,
  ACCOUNT_NUMBER_REQ,
  FILE_TYPE_REQ,
  SPEC_THERA_CD_REQ,
  CLASS_FIELD_REQ,
  BUDGET_REF_REQ,
  THRESHOLD_NO_OF_UNITS_REQ,
  MAIL_ORDER_MULTIPLIER_REQ,
  SUCCESS_MESSAGE,
  DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE,
  DUPLICATE_HOLIDAY_DATE_ERROR,
} from '../../../../SharedModules/Errors/constantMessageData';

import {
  getDefaultAuditDetails,
  getgeneralsystemparameterDetails,
  updateHolidayDetails,
  updateMDSpecTheraDetails,
  updateNMAccountDetails,
  updateNMFineCdDetails,
  updateSystemDetails,
  dispatchErrorMessages,
  dispatchSuccessMessage,
  dispatchTabValue,
  dispatchDisabledSaveCancelBtn,
  resetSystemParameterStore,
  dispatchSetHolidaysDetails,
  getHolidaysDetails,
  getMaxActivityDt,
  getNMAccountDetails,
  getNMFinCode,
  updateDefaultAuditData
} from '../store/actions';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SaveCancelPopup from '../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  convertQuatreManufacturer,
  closeTab,
  validDate,
  handleScrollToEvent,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { compareTwoDatesGreaterThanOrEqual } from '../../../../SharedModules/DateUtilities/DateUtilities';
import { isReadOnly as isRead, checkActionAccessByRole } from '../../../../SharedModules/utilities/utilities';

const styles = {
  selected: {
    fontSize: '16px',
    fontWeight: '600',
    color: 'black',
  },
};

const Tab = withStyles(styles)((props) => <MuiTab {...props} />);

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 1 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
const getIsEnabledByRole = (roles) =>
  checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, roles) &&
  checkActionAccessByRole(process.env.REACT_APP_NORMAL_ONLY_ROLE, roles);

function BasicTabs({ location }) {
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const isNormalUserRestricted = !checkActionAccessByRole(
    process.env.REACT_APP_NORMAL_ONLY_ROLE,
    kcRoles
  );
  let isReadOnly = false;
  if (loginState) {
    isReadOnly = isRead(location.pathname, loginState)?.readOnly || false;
  }
  if (isNormalUserRestricted) {
    isReadOnly = true;
  }
  const dispatch = useDispatch();
  const updateHolidayDetail = useCallback((value) => {
    dispatch(updateHolidayDetails(value));
  }, []);
  const updateMDSpecTheraDetail = useCallback((value) => {
    dispatch(updateMDSpecTheraDetails(value));
  }, []);
  const updateSystemDetail = (value) => dispatch(updateSystemDetails(value));
  // const updateMDSpecTheraDetail = (value) =>
  //   dispatch(updateMDSpecTheraDetails(value));
  const updateNMAccountDetail = (value) =>
    dispatch(updateNMAccountDetails(value));
  const updateNMFineCdDetail = (value) =>
    dispatch(updateNMFineCdDetails(value));

  const generalSystemParameterData = useSelector(
    (state) =>
      state?.sharedState?.SystemProviderReducer?.generalSystemParameter
        ?.paramGeneralVO
  );

  const payload = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.defaultAudit?.data
  );

  const updatedSystemDetails = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.updatedSystemDetails
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const defaultAuditDataRedux = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.defaultAuditDataRedux
  );
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const errorMessages = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.errorMessages
  );
  const successMessage = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.successMessage
  );
  const tabValue = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.tabValue
  );
  const disabledSaveCancelBtn = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.disabledSaveCancelBtn
  );
  const specinsys = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.specinsys
  );
  const nmAccInSys = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.nmAccInSys
  );
  const nmFinInSys = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.nmFinInSys
  );
  const mdSpecTabInd = useSelector(
    (state) =>
      state?.sharedState?.SystemProviderReducer?.generalSystemParameter
        ?.paramGeneralVO?.[0]?.mdStcTabInd
  );
  const nmArTabsInd = useSelector(
    (state) =>
      state?.sharedState?.SystemProviderReducer?.generalSystemParameter
        ?.paramGeneralVO?.[0]?.nmArTabInd
  );
  React.useEffect(() => {
    setUpdateMDSpecThera(specinsys);
  }, [specinsys]);
  React.useEffect(() => {
    setUpdateNMAccount(nmAccInSys);
  }, [nmAccInSys]);
  React.useEffect(() => {
    setUpdateNMFincode(nmFinInSys);
  }, [nmFinInSys]);
  React.useEffect(() => {
    setSuccessMessage([]);
  }, [tabValue]);
  const setErrorMessages = (messages) => {
    dispatch(dispatchErrorMessages(messages));
  };
  const setSuccessMessage = (messages) => {
    dispatch(dispatchSuccessMessage(messages));
  };
  const setTabValue = (data) => {
    dispatch(dispatchTabValue(data));
  };
  const setDisabledSaveCancelBtn = (data) => {
    dispatch(dispatchDisabledSaveCancelBtn(data));
  };

  const [updateHoliday, setUpdateHoliday] = useState();
  const [updateMDSpecThera, setUpdateMDSpecThera] = useState();
  const [updateNMAccount, setUpdateNMAccount] = useState();
  const [updateNMFincode, setUpdateNMFincode] = useState();
  const [updatDefaultTable, setUpdateDefaultTable] = useState([]);
  const [updateGenSysparameter, setUpdateGenSysparameter] = useState();
  const [updateDefSysparameter, setUpdateDefSysparameter] = useState();
  const [updateDefaultAudit, setUpdateDefaultAudit] = useState([]);
  const [codeValueData, setCodeValueData] = useState();
  const [defCodeValueData, setDefCodeValueData] = useState([]);
  const [systemParameterData, setSystemParameterData] = useState([]);
  const [fullScreenView, setFullScreenView] = useState(false);
  const [open, setOpen] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [isEnabledByRole, setIsEnabledByRole] = useState(
    getIsEnabledByRole(kcRoles)
  );
  const [clickOncloseTabBtn, setClickOncloseTabBtn] = React.useState(false);
  const history = useHistory();
  const [saveClicked, setSaveClicked] = useState(false);
  const [resetDefaultUnitTypeFlag, setResetDefaultUnitTypeFlag] =
    useState(false);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // handling refresh functionality
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/systemparameter' && !disabledSaveCancelBtn) {
          item.isFormDirty = true;
          if (errorMessages && errorMessages.length > 0) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        } else if (item.navTo === '/systemparameter') item.isFormDirty = false;
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [disabledSaveCancelBtn, errorMessages]);
  useEffect(() => {
    handleScrollToEvent();
    dispatch(getMaxActivityDt());
  }, []);
  useEffect(() => {
    if (kcRoles?.userPrivileges?.length > 0) {
      setIsEnabledByRole(getIsEnabledByRole(kcRoles));
    }
  }, [kcRoles]);
  // close popup on click button
  useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/systemparameter' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.map((item) => {
        if (item.navTo === '/systemparameter' && item.isFormSave) {
          item.isFormSave = false;
          if (validation()) {
            setClickOncloseTabBtn(true);
            setErrorMessages([]);
            dispatch(resetSystemParameterStore());
            saveData();
          }
        }
        return item;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  useEffect(() => {
    if (generalSystemParameterData && generalSystemParameterData.length > 0)
      setSystemParameterData(generalSystemParameterData[0]);
  }, [generalSystemParameterData]);

  const formatData = () => {
    if (updateDefSysparameter || updateGenSysparameter) {
      systemParameterData.defShowDisputeOnInvInd = updateDefSysparameter
        ? updateDefSysparameter.defShowDisputeOnInvInd
        : systemParameterData.defShowDisputeOnInvInd;
      systemParameterData.defForgiveReqCommentInd = updateDefSysparameter
        ? updateDefSysparameter.defForgiveReqCommentInd
        : systemParameterData.defForgiveReqCommentInd;
      systemParameterData.defUnitConvChangesDataInd = updateDefSysparameter
        ? updateDefSysparameter.defUnitConvChangesDataInd
        : systemParameterData.defUnitConvChangesDataInd;
      systemParameterData.defAutoUnderThresholdInd = updateDefSysparameter
        ? updateDefSysparameter.defAutoUnderThresholdInd
        : systemParameterData.defAutoUnderThresholdInd;
      systemParameterData.defNonZeroBilledUnitsInd = updateDefSysparameter
        ? updateDefSysparameter.defNonZeroBilledUnitsInd
        : systemParameterData.defNonZeroBilledUnitsInd;
      systemParameterData.defReimbUnderThresholdMult = updateDefSysparameter
        ? updateDefSysparameter.defReimbUnderThresholdMult
        : systemParameterData.defReimbUnderThresholdMult;
      systemParameterData.defSendAllRetainedQtr = updateDefSysparameter
        ? updateDefSysparameter.defSendAllRetainedQtr
        : systemParameterData.defSendAllRetainedQtr;
      systemParameterData.defInvoiceMailThreshold = updateDefSysparameter
        ? updateDefSysparameter.defInvoiceMailThreshold
        : systemParameterData.defInvoiceMailThreshold;
      systemParameterData.defWindowAddrPos = updateDefSysparameter
        ? updateDefSysparameter.defWindowAddrPos
        : systemParameterData.defWindowAddrPos;
      systemParameterData.checkLogByCcnInd = updateGenSysparameter
        ? updateGenSysparameter.checkLogByCcnInd
        : systemParameterData.checkLogByCcnInd;
      systemParameterData.checkLogUsesBatchInd = updateGenSysparameter
        ? updateGenSysparameter.checkLogUsesBatchInd
        : systemParameterData.checkLogUsesBatchInd;
      systemParameterData.allowNewCgpInd = updateGenSysparameter
        ? updateGenSysparameter.allowNewCgpInd
        : systemParameterData.allowNewCgpInd;
      systemParameterData.hideCmsUraInd = updateGenSysparameter
        ? updateGenSysparameter.hideCmsUraInd
        : systemParameterData.hideCmsUraInd;
      systemParameterData.ftpCmsTapeInd = updateGenSysparameter
        ? updateGenSysparameter.ftpCmsTapeInd
        : systemParameterData.ftpCmsTapeInd;
      systemParameterData.preventCcUpdateInd = updateGenSysparameter
        ? updateGenSysparameter.preventCcUpdateInd
        : systemParameterData.preventCcUpdateInd;
      systemParameterData.strongPwReqInd = updateGenSysparameter
        ? updateGenSysparameter.strongPwReqInd
        : systemParameterData.strongPwReqInd;
      systemParameterData.ftpIpAddress = updateGenSysparameter
        ? updateGenSysparameter.ftpIpAddress
        : systemParameterData.ftpIpAddress;
      systemParameterData.ftpUserId = updateGenSysparameter
        ? updateGenSysparameter.ftpUserId
        : systemParameterData.ftpUserId;
      systemParameterData.ftpPassword = updateGenSysparameter
        ? updateGenSysparameter.ftpPassword
        : systemParameterData.ftpPassword;
      systemParameterData.showSpecialTheraClassInd = updateGenSysparameter
        ? updateGenSysparameter.showSpecialTheraClassInd
        : systemParameterData.showSpecialTheraClassInd;
      systemParameterData.drugGrossAmtInd = updateGenSysparameter
        ? updateGenSysparameter.drugGrossAmtInd
        : systemParameterData.drugGrossAmtInd;
      systemParameterData.secLoginInd = updateGenSysparameter
        ? updateGenSysparameter.secLoginInd
        : systemParameterData.secLoginInd;
      systemParameterData.secLoginMsg = updateGenSysparameter
        ? updateGenSysparameter.secLoginMsg
        : systemParameterData.secLoginMsg;
    }

    return systemParameterData;
  };

  const tableDataMap = () => {
    defCodeValueData.filter((item) => {
      if( !codeValueData || codeValueData.length<=0) return
   (codeValueData || []).map((dataItem) => {
        if (
          item.paramTestIdVO.defTestUnitTypeCd === dataItem.shortDescription
        ) {
          item.paramTestIdVO.defTestUnitTypeCd = dataItem.codeValueID.codeValue;
        }
      });
    });
    setUpdateDefaultTable(defCodeValueData);
  };

  const formDefaultAuditPayload = () => {
    const updatedItemsList = [];
    const errorList = [];
    if (payload && payload.paramTestVO && defaultAuditDataRedux) {
      const tempPayloadObj = payload.paramTestVO;
      tempPayloadObj.map((item) => {
        if (
          item.paramTestIdVO.defTestGroupCd === 'C' &&
          item.paramTestIdVO.defTestTypeCd === 'UNA'
        ) {
          if (
            !defaultAuditDataRedux[0].percentAverageUnits.defTestPct &&
            defaultAuditDataRedux[0].unitsGreaterThenAvgNDCPeviousQuarter
          ) {
            errorList.push(PERCENT_AVERAGE_UNITS_REQ);
          } else if (
            item.defTestPct !==
              defaultAuditDataRedux[0].percentAverageUnits.defTestPct ||
            item.defTestOnInd !==
              defaultAuditDataRedux[0].unitsGreaterThenAvgNDCPeviousQuarter
          ) {
            item.defTestPct =
              defaultAuditDataRedux[0].percentAverageUnits.defTestPct / 100;
            item.defTestOnInd = defaultAuditDataRedux[0]
              .unitsGreaterThenAvgNDCPeviousQuarter
              ? 1
              : 0;
            updatedItemsList.push(item);
          }
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'C' &&
          item.paramTestIdVO.defTestTypeCd === 'RES'
        ) {
          if (
            item.defTestOnInd !==
            defaultAuditDataRedux[0].unitsGreaterThenAvgNDCPeviousQuarter
          ) {
            item.defTestOnInd = defaultAuditDataRedux[0].reimbursedSubmitted
              ? 1
              : 0;
            updatedItemsList.push(item);
          }
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'C' &&
          item.paramTestIdVO.defTestTypeCd === 'AES'
        ) {
          if (
            !defaultAuditDataRedux[0].percentSubmittedAmount.defTestPct &&
            defaultAuditDataRedux[0].allowedAmountExceedsSubmittedAmt
          ) {
            errorList.push(PERCENT_SUBMITTED_AMOUNT_REQ);
          } else if (
            item.defTestPct !==
              defaultAuditDataRedux[0].percentSubmittedAmount.defTestPct ||
            item.defTestOnInd !==
              defaultAuditDataRedux[0].allowedAmountExceedsSubmittedAmt
          ) {
            item.defTestPct =
              defaultAuditDataRedux[0].percentSubmittedAmount.defTestPct / 100;
            item.defTestOnInd = defaultAuditDataRedux[0]
              .allowedAmountExceedsSubmittedAmt
              ? 1
              : 0;
            updatedItemsList.push(item);
          }
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'C' &&
          item.paramTestIdVO.defTestTypeCd === 'SRA'
        ) {
          if (
            !defaultAuditDataRedux[0].percentSubmittedAmountReimbursed
              .defTestPct &&
            defaultAuditDataRedux[0].reimbursedAmtLessThanSubmitted
          ) {
            errorList.push(PERCENT_SUBMITTED_AMOUNT_REQ);
          } else if (
            item.defTestPct !==
              defaultAuditDataRedux[0].percentSubmittedAmountReimbursed
                .defTestPct ||
            item.defTestOnInd !==
              defaultAuditDataRedux[0].reimbursedAmtLessThanSubmitted
          ) {
            item.defTestPct =
              defaultAuditDataRedux[0].percentSubmittedAmountReimbursed
                .defTestPct / 100;
            item.defTestOnInd = defaultAuditDataRedux[0]
              .reimbursedAmtLessThanSubmitted
              ? 1
              : 0;
            updatedItemsList.push(item);
          }
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'C' &&
          item.paramTestIdVO.defTestTypeCd === 'RLA'
        ) {
          if (
            !defaultAuditDataRedux[0].percentAllowedAmounts.defTestPct &&
            defaultAuditDataRedux[0].reimbursedAmountLessThanAllowed
          ) {
            errorList.push(PERCENT_ALLOWED_AMOUNT_REQ);
          } else if (
            item.defTestPct !==
              defaultAuditDataRedux[0].percentAllowedAmounts.defTestPct ||
            item.defTestOnInd !==
              defaultAuditDataRedux[0].reimbursedAmountLessThanAllowed
          ) {
            item.defTestPct =
              defaultAuditDataRedux[0].percentAllowedAmounts.defTestPct / 100;
            item.defTestOnInd = defaultAuditDataRedux[0]
              .reimbursedAmountLessThanAllowed
              ? 1
              : 0;
            updatedItemsList.push(item);
          }
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'C' &&
          item.paramTestIdVO.defTestTypeCd === 'STR'
        ) {
          if (
            !defaultAuditDataRedux[0].thresholdamount.defTestAmt &&
            defaultAuditDataRedux[0].amountSubmittedGreaterThanThreshold
          ) {
            errorList.push(THRESHOLD_AMOUNT_REQ);
          } else if (
            item.defTestAmt !==
              defaultAuditDataRedux[0].thresholdamount.defTestAmt ||
            item.defTestOnInd !==
              defaultAuditDataRedux[0].amountSubmittedGreaterThanThreshold
          ) {
            item.defTestAmt =
              defaultAuditDataRedux[0].thresholdamount.defTestAmt;
            item.defTestOnInd = defaultAuditDataRedux[0]
              .amountSubmittedGreaterThanThreshold
              ? 1
              : 0;
            updatedItemsList.push(item);
          }
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'C' &&
          item.paramTestIdVO.defTestTypeCd === 'IDC'
        ) {
          if (
            item.defTestOnInd !==
              defaultAuditDataRedux[0].identifyDuplicateClaimsItem
                .defTestOnInd ||
            item.defTestOnInd !==
              defaultAuditDataRedux[0].identifyDuplicateClaims
          ) {
            item.defTestOnInd = defaultAuditDataRedux[0]
              .identifyDuplicateClaimsItem.defTestOnInd
              ? 1
              : 0;
            item.defTestOnInd = defaultAuditDataRedux[0].identifyDuplicateClaims
              ? 1
              : 0;
            updatedItemsList.push(item);
          }
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'I' &&
          item.paramTestIdVO.defTestTypeCd === 'UNP'
        ) {
          if (
            !defaultAuditDataRedux[0].percentPriorquarter.defTestPct &&
            defaultAuditDataRedux[0].unitsGreaterThanPriorQuarter
          ) {
            errorList.push(PERCENT_PRIOR_QUARTER_REQ);
          } else if (
            item.defTestPct !==
              defaultAuditDataRedux[0].percentPriorquarter.defTestPct ||
            item.defTestOnInd !==
              defaultAuditDataRedux[0].unitsGreaterThanPriorQuarter
          ) {
            item.defTestPct =
              defaultAuditDataRedux[0].percentPriorquarter.defTestPct / 100;
            item.defTestOnInd = defaultAuditDataRedux[0]
              .unitsGreaterThanPriorQuarter
              ? 1
              : 0;
            updatedItemsList.push(item);
          }
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'I' &&
          item.paramTestIdVO.defTestTypeCd === 'RGR'
        ) {
          if (
            !defaultAuditDataRedux[0].percentreimbursedamount.defTestPct &&
            defaultAuditDataRedux[0].rebateChargedGreaterThanReimbursedAmount
          ) {
            errorList.push(PERCENT_REIMBURSED_AMOUNT_REQ);
          } else if (
            item.defTestPct !==
              defaultAuditDataRedux[0].percentreimbursedamount.defTestPct ||
            item.defTestOnInd !==
              defaultAuditDataRedux[0].rebateChargedGreaterThanReimbursedAmount
          ) {
            item.defTestPct =
              defaultAuditDataRedux[0].percentreimbursedamount.defTestPct / 100;
            item.defTestOnInd = defaultAuditDataRedux[0]
              .rebateChargedGreaterThanReimbursedAmount
              ? 1
              : 0;
            updatedItemsList.push(item);
          }
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'I' &&
          item.paramTestIdVO.defTestTypeCd === 'RGP'
        ) {
          if (
            !defaultAuditDataRedux[0].percentPriorquarterNDC.defTestPct &&
            defaultAuditDataRedux[0]
              .rebateForThisNDCExceedsRebateForPreviousQuarter
          ) {
            errorList.push(PERCENT_PRIOR_QUARTER_REQ);
          } else if (
            item.defTestPct !==
              defaultAuditDataRedux[0].percentPriorquarterNDC.defTestPct ||
            item.defTestOnInd !==
              defaultAuditDataRedux[0]
                .rebateForThisNDCExceedsRebateForPreviousQuarter
          ) {
            item.defTestPct =
              defaultAuditDataRedux[0].percentPriorquarterNDC.defTestPct / 100;
            item.defTestOnInd = defaultAuditDataRedux[0]
              .rebateForThisNDCExceedsRebateForPreviousQuarter
              ? 1
              : 0;
            updatedItemsList.push(item);
          }
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'I' &&
          item.paramTestIdVO.defTestTypeCd === 'RGL'
        ) {
          if (
            !defaultAuditDataRedux[0].percentPriorquarterLabler.defTestPct &&
            defaultAuditDataRedux[0]
              .rebateForThisLabelerExceedsRebateForPreviousQuarter
          ) {
            errorList.push(PERCENT_PRIOR_QUARTER_REQ);
          } else if (
            item.defTestPct !==
              defaultAuditDataRedux[0].percentPriorquarterLabler.defTestPct ||
            item.defTestOnInd !==
              defaultAuditDataRedux[0]
                .rebateForThisLabelerExceedsRebateForPreviousQuarter
          ) {
            item.defTestPct =
              defaultAuditDataRedux[0].percentPriorquarterLabler.defTestPct /
              100;
            item.defTestOnInd = defaultAuditDataRedux[0]
              .rebateForThisLabelerExceedsRebateForPreviousQuarter
              ? 1
              : 0;
            updatedItemsList.push(item);
          }
        }
        if (errorList.length > 0) {
          return errorList;
        }
        return updatedItemsList;
      });
      if (errorList.length > 0) {
        setErrorMessages(errorList);
        return false;
      }
      return tempPayloadObj;
    }
  };

  useEffect(() => {
    if (updatedSystemDetails) {
      setDisabledSaveCancelBtn(true);
      dispatch(getNMAccountDetails({}));
      dispatch(getNMFinCode({}));
      if (clickOncloseTabBtn) {
        closeTab('/systemparameter', history);
      }
      if (updatedSystemDetails.status === '001') {
        setSuccessMessage([SUCCESS_MESSAGE]);
      } else {
        setErrorMessages([FAILED_MESSAGE_GENERIC]);
      }
    }
  }, [updatedSystemDetails]);

  const validation = () => {
    const errorList = [];
    let showStrtDtErr = false;
    const showQtrErr = false;
    if (
      updateDefSysparameter?.defInvoiceMailThreshold &&
      updateDefSysparameter?.defInvoiceMailThreshold > 50
    ) {
      errorList.push(MAX_THRESHOLD_ALLOWED);
    }
    if (
      updateDefSysparameter?.defSendAllRetainedQtr &&
      updateDefSysparameter?.defSendAllRetainedQtr > 4
    ) {
      errorList.push(MAX_RETAINED_QTR);
    }

    updatDefaultTable &&
      updatDefaultTable.forEach((item, index) => {
        if (item.defTestOnInd) {
          if (!item.defTestAmt) {
            errorList.push(`${THRESHOLD_NO_OF_UNITS_REQ} in row #${index + 1}`);
          }
          if (!item.defMailOrderMultiplier) {
            errorList.push(`${MAIL_ORDER_MULTIPLIER_REQ} in row #${index + 1}`);
          }
        }
      });

    updateNMFincode &&
      updateNMFincode.forEach((item, index) => {
        if (item?.rpcArInterfaceIdVO?.nmFinStartQtr === '') {
          errorList.push(`${START_QTR_UC}#${index + 1} of NM Fin Code tab.`);
        }
        if (
          item?.rpcArInterfaceIdVO?.nmFinStartQtr !== '' &&
          item?.rpcArInterfaceIdVO?.nmFinStartQtr !== null &&
          !convertQuatreManufacturer(item?.rpcArInterfaceIdVO?.nmFinStartQtr)
        ) {
          errorList.push(`${QUARTER_FORMAT_ERROR} in row #${index + 1}.`);
        }

        if (!item?.rpcArInterfaceIdVO?.nmFinBudgetRef) {
          errorList.push(`${BUDGET_REF_REQ} in row #${index + 1}.`);
        }
        if (!item?.rpcArInterfaceIdVO?.nmFinClass) {
          errorList.push(`${CLASS_FIELD_REQ} in row #${index + 1}.`);
        }
      });

    updateMDSpecThera &&
      updateMDSpecThera.forEach((item, index) => {
        let endQtrDate = '';
        let startQtrDate = '';
        if (!item.specTheraClassCd) {
          errorList.push(`${SPEC_THERA_CD_REQ} in row #${index + 1}`);
        }
        if (item.startQtr === '') {
          showStrtDtErr = true;
          errorList.push(
            `${START_QTR_UC} in row #${index + 1} of MD Spec Thera tab`
          );
        }
        if (
          item.startQtr !== '' &&
          item.startQtr !== null &&
          !convertQuatreManufacturer(item.startQtr)
        ) {
          errorList.push(`${QUARTER_FORMAT_ERROR} in row #${index + 1}`);
        }
        if (
          item.endQtr !== '' &&
          item.endQtr !== null &&
          !convertQuatreManufacturer(item.endQtr)
        ) {
          errorList.push(`${QUARTER_FORMAT_ERROR} in row #${index + 1}`);
        }
        if (!showQtrErr && !showStrtDtErr && item.startQtr && item.endQtr) {
          startQtrDate = convertQuatreManufacturer(item.startQtr);
          endQtrDate = convertQuatreManufacturer(item.endQtr);
          if (endQtrDate && startQtrDate) {
            if (
              compareTwoDatesGreaterThanOrEqual(
                new Date(endQtrDate),
                moment(new Date(startQtrDate)).add('days', 1)
              )
            ) {
              errorList.push(`${END_QTR_ERROR} in row #${index + 1}`);
            }
          }
        }
      });

    updateNMAccount &&
      updateNMAccount.forEach((item, index) => {
        if (item?.nmAccountIdVO?.startQtr === '' && !item?.isDeleteFlag) {
          errorList.push(
            `${START_QTR_UC}#${index + 1} of NM Account Number tab.`
          );
        }
        if (
          item?.nmAccountIdVO?.startQtr !== '' &&
          item?.nmAccountIdVO?.startQtr !== null &&
          !convertQuatreManufacturer(item?.nmAccountIdVO?.startQtr) &&
          !item?.isDeleteFlag
        ) {
          errorList.push(`${QUARTER_FORMAT_ERROR} in row #${index + 1}.`);
        }

        if (!item?.nmAccountIdVO?.fileType && !item?.isDeleteFlag) {
          errorList.push(`${FILE_TYPE_REQ} in row #${index + 1}`);
        }
        if (!item?.nmAccountIdVO?.accountNumber && !item?.isDeleteFlag) {
          errorList.push(`${ACCOUNT_NUMBER_REQ} in row #${index + 1}`);
        }
      });
    //   const newObj =
    //     updateHoliday &&
    //     updateHoliday.map((item, index) => {
    //       let duplicateIndex = -1; // Variable to store the index of the duplicate item
    //       // Check for missing or invalid holiday dates
    //       if (
    //         item.holidayDt === '' ||
    //         item.holidayDt === null ||
    //         item.holidayDt === 'Invalid Date'
    //       ) {
    //         item.holidayDtErr = true;
    //         errorList.push(`${HOLIDAY_DATE_REQUIRED}${index + 1}.`);
    //       } else if (
    //         validDate(new Date(item.holidayDt)) === false &&
    //         !item?.deleteFlag
    //       ) {
    //         item.holidayDtErr = true;
    //         errorList.push(
    //           `${DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE}${index + 1}.`
    //         );
    //       }

    //       // Check for missing holiday description
    //       if (!item.holidayDescr && !item?.deleteFlag) {
    //         errorList.push(`${HOLIDAY_DESC_REQ}${index + 1}.`);
    //         item.holidayDesErr = true;
    //       }

    //       // Check for duplicate holiday dates
    //       updateHoliday.forEach((otherItem, otherIndex) => {
    //         if (
    //           index !== otherIndex && // Avoid comparing the same item
    //           !otherItem?.deleteFlag && // Only consider non-deleted items
    //           item.holidayDt === otherItem.holidayDt // Compare holiday dates
    //         ) {
    //           duplicateIndex = otherIndex;
    //         }
    //       });

    //       // If duplicate is found, push a single error message
    //       if (duplicateIndex !== -1) {
    //         errorList.push(
    //           `${DUPLICATE_HOLIDAY_DATE_ERROR} at row ${duplicateIndex + 1}.`
    //         );
    //         item.holidayDtErr = true;
    //       }

    //       return item;
    //     });

    //   dispatch(dispatchSetHolidaysDetails(newObj));
    //   if (
    //     errorList.length > 0 ||
    //     updateHoliday?.filter((x) => {
    //       return x.holidayDtErr || x.holidayDesErr;
    //     })?.length > 0
    //   ) {
    //     setErrorMessages(errorList);
    //     return false;
    //   }
    //   setErrorMessages([]);
    //   return true;
    // };

    const newObj = updateHoliday?.map((item, index) => {
      let duplicateIndex = -1; // Variable to store the index of the duplicate item

      // Check for missing or invalid holiday dates
      if (!item.holidayDt || item.holidayDt === 'Invalid Date') {
        item.holidayDtErr = true;
        errorList.push(`${HOLIDAY_DATE_REQUIRED}${index + 1}.`);
      } else if (!validDate(new Date(item.holidayDt)) && !item.deleteFlag) {
        item.holidayDtErr = true;
        errorList.push(
          `${DATE_INVALID_FORMAT_ERROR_HOLIDAY_DATE}${index + 1}.`
        );
      }

      // Check for missing holiday description
      if (!item.holidayDescr && !item.deleteFlag) {
        item.holidayDesErr = true;
        errorList.push(`${HOLIDAY_DESC_REQ}${index + 1}.`);
      }

      // Check for duplicate holiday dates
      updateHoliday.forEach((otherItem, otherIndex) => {
        if (
          index !== otherIndex && // Avoid comparing the same item
          !otherItem.deleteFlag && // Only consider non-deleted items
          !item.deleteFlag && // Ensure the current item is not deleted
          item.holidayDt === otherItem.holidayDt // Compare holiday dates
        ) {
          duplicateIndex = otherIndex;
        }
      });

      // If duplicate is found, push a single error message
      if (duplicateIndex !== -1) {
        errorList.push(
          `${DUPLICATE_HOLIDAY_DATE_ERROR} at row ${duplicateIndex + 1}.`
        );
        item.holidayDtErr = true;
      } else {
        // If no duplicate found, clear error message for the current item
        const existingErrorMessageIndex = errorList.findIndex((message) =>
          message.includes(
            `${DUPLICATE_HOLIDAY_DATE_ERROR} at row ${index + 1}.`
          )
        );
        if (existingErrorMessageIndex !== -1) {
          errorList.splice(existingErrorMessageIndex, 1);
          item.holidayDtErr = false;
        }
      }

      return item;
    });

    // Check if there are any errors
    if (errorList?.length > 0) {
      setErrorMessages(errorList);
      return false;
    }
    // Dispatch the updated holiday details
    dispatch(dispatchSetHolidaysDetails(newObj));

    // Clear error messages if there are no errors
    setErrorMessages([]);
    return true;
  };

  const handleCancel = () => {
    // setResetDefaultUnitTypeFlag((prev)=>!prev)
    onReset();
    dispatch(getNMAccountDetails({}));
    dispatch(getNMFinCode({}));
  };
  const searchHolidayDetail = (value) => dispatch(getHolidaysDetails(value));
  const saveData = async () => {
    tableDataMap();
    setSuccessMessage([]);
    setErrorMessages([]);
    const defaultAuditData = formDefaultAuditPayload();
    if (defaultAuditData) {
      const samplePayload = [...updatDefaultTable, ...defaultAuditData,...defCodeValueData];
      const systemData = formatData();
      const paramTestVO = [
        {
          paramTestVO: samplePayload,
          paramGeneralVO: [systemData],
        },
      ];
      updateSystemDetail(paramTestVO[0]);
      if (updateHoliday) {
        const changedHolidays = updateHoliday
          ?.filter((x) => x.newRow || x.updateRecord || x.deleteFlag)
          ?.map((item) => {
            const copy = { ...item };
            delete copy.id;
            delete copy.holidayDesErr;
            delete copy.holidayDtErr;
            delete copy.newRow;
            delete copy.updateRecord;
            if (copy.holidayDt) {
              copy.holidayDt = moment(copy.holidayDt).format('MM/DD/YYYY');
            }
            if (copy.lastUpdateDt) {
              copy.lastUpdateDt = moment(copy.lastUpdateDt).format('MM/DD/YYYY');
            }
            copy.lastUpdateUserId = UserDefaultValues?.userId || 'DRAMS';
            return copy;
          });
        if (changedHolidays?.length > 0) {
          updateHolidayDetail(changedHolidays);
          setUpdateHoliday(updateHoliday);
        }
      }

      if (updateMDSpecThera) {
        updateMDSpecTheraDetail(updateMDSpecThera);
      }
      if (updateNMAccount) {
        let tempObj = [];
        tempObj = updateNMAccount
          ?.filter((x) => {
            return x.newRecord || x.updateRecord || x.deleteRecord;
          })
          ?.map((item) => {
            delete item.id;
            delete item.startQtrErr;
            delete item.fileTypeErr;
            delete item.accountNumberErr;
            return item;
          });
        if (tempObj?.length > 0) {
          updateNMAccountDetail(tempObj);
        }
      }
      if (updateNMFincode) {
        let newObj = [];
        newObj = updateNMFincode
          ?.filter((x) => {
            return x.newRecord || x.updateRecord || x.deleteRecord;
          })
          ?.map((item) => {
            if (item.newRecord) {
              item.oldNMFinStartQtr = item.rpcArInterfaceIdVO.nmFinStartQtr;
              item.oldNMFinBudgetRef = item.rpcArInterfaceIdVO.nmFinBudgetRef;
              item.oldNMFinClass = item.rpcArInterfaceIdVO.nmFinClass;
            }
            delete item.id;
            delete item.startQtrErr;
            delete item.nmFinBudgetRefErr;
            delete item.nmFinClassErr;
            return item;
          });
        if (newObj?.length > 0) {
          updateNMFineCdDetail(newObj);
        }
      }
    }
  };
  const onSubmit = () => {
    if (validation()) {
      setOpen(true);
    }
  };
  const onReset = () => {
    setDisabledSaveCancelBtn(true);
    if (logInUser) {
      dispatch(getDefaultAuditDetails());
      dispatch(getgeneralsystemparameterDetails());
    }
    setSuccessMessage([]);
    setErrorMessages([]);
  };

  useEffect(() => {
    if (!payload) {
      onReset();
    }
  }, []);

  React.useEffect(() => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    if (systemParameterData && Object.keys(systemParameterData).length > 0) {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === '/systemparameter' && !disabledSaveCancelBtn) {
            item.isFormDirty = true;
            if (errorMessages && errorMessages.length > 0) {
              item.isFormError = true;
            } else {
              item.isFormError = false;
            }
          } else if (item.navTo === '/systemparameter')
            item.isFormDirty = false;
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    }
  }, [disabledSaveCancelBtn || systemParameterData]);

  return ( 
    <>
      <div className="tabs-container">
        <SaveCancelPopup
          open={open}
          title="Save"
          onConfim={() => {
            setSaveClicked(true)
            saveData();
            setOpen(false);
          }}
          onCancel={() => {
            setOpen(false);
          }}
        />
        <SaveCancelPopup
          open={openCancel}
          title="Cancel"
          onConfim={() => {
            setResetDefaultUnitTypeFlag(true)
            handleCancel();
            setOpenCancel(false);
          }}
          onCancel={() => {
            setOpenCancel(false);
          }}
        />
        <CustomSeparator parent1="System" parent2="System Parameters" />
        {!fullScreenView && (
          <>
            <Spinner load={spinnerLoader} />
            <DisplaySuccessMessages successMessages={successMessage} />
            <DisplayErrorMessages errorMessages={[...new Set(errorMessages)]} />
          </>
        )}
        {!fullScreenView && (
          <div className="btn-wrapper mb-2">
            <div className="float-right mt-2 hide-on-print">
              <Button
                className="btn btn-success btn-search"
                data-testid="saveBtn"
                disabled={isReadOnly || disabledSaveCancelBtn || !isEnabledByRole}
                onClick={() => onSubmit(true)}
              >
                <SVGComponent iconName="Icon-awesome-save" />
                Save
              </Button>
              <Button
                onClick={() => setOpenCancel(true)}
                data-testid="cancelBtn"
                disabled={isReadOnly || disabledSaveCancelBtn || !isEnabledByRole}
                className="btn btn-cancel btn btn-primary"
              >
                <SVGComponent iconName="Icon-cancel" />
                Cancel
              </Button>
            </div>
            <div className="clearfix" />
          </div>
        )}
        {!fullScreenView && (
          <AppBar position="static">
            <Box>
              <Tabs
                value={tabValue}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="simple tabs example"
              >
                <Tab
                  label="Default Audits"
                  value={0}
                  {...a11yProps(0)}
                  tabIndex={0}
                />
                {errorMessages?.filter((x) => {
                  return (
                    x === MAX_THRESHOLD_ALLOWED ||
                    x === MAX_RETAINED_QTR ||
                    x === PERCENT_AVERAGE_UNITS_REQ ||
                    x === PERCENT_SUBMITTED_AMOUNT_REQ ||
                    x === PERCENT_ALLOWED_AMOUNT_REQ ||
                    x === THRESHOLD_AMOUNT_REQ ||
                    x === PERCENT_PRIOR_QUARTER_REQ ||
                    x === PERCENT_REIMBURSED_AMOUNT_REQ
                  );
                }).length > 0 && <span className="tab-error">!</span>}
                <Tab
                  label="Default Unit Type Audits"
                  {...a11yProps(1)}
                  tabIndex={1}
                  value={1}
                />
                {errorMessages?.filter((x) => {
                  return (
                    x?.includes(THRESHOLD_NO_OF_UNITS_REQ) ||
                    x?.includes(MAIL_ORDER_MULTIPLIER_REQ)
                  );
                }).length > 0 && <span className="tab-error">!</span>}
                <Tab
                  label="General System Parameters"
                  {...a11yProps(2)}
                  tabIndex={2}
                  value={2}
                />
                <Tab
                  label="Default System Parameters"
                  {...a11yProps(3)}
                  tabIndex={3}
                  value={3}
                />

                <Tab
                  label="Holidays"
                  value={4}
                  tabIndex={4}
                  {...a11yProps(4)}
                />
                {errorMessages?.filter((x) => {
                  return (
                    x?.includes('date in MM/DD/YYYY format') ||
                    x?.includes('Holiday Date') ||
                    x?.includes('Holiday Description is')
                  );
                }).length > 0 && <span className="tab-error">!</span>}

                {mdSpecTabInd === 1 && (
                  <Tab
                    label="MD Spec Thera"
                    value={5}
                    {...a11yProps(5)}
                    tabIndex={5}
                  />
                )}
                {mdSpecTabInd === 1 &&
                  errorMessages?.filter((x) => {
                    return (
                      (x?.includes(START_QTR_UC) &&
                        x?.includes('MD Spec Thera')) ||
                      (x?.includes(QUARTER_FORMAT_ERROR) &&
                        x?.includes('MD Spec Thera')) ||
                      x?.includes(END_QTR_ERROR) ||
                      x?.includes(SPEC_THERA_CD_REQ)
                    );
                  }).length > 0 && <span className="tab-error">!</span>}
                {nmArTabsInd === 1 && (
                  <Tab
                    label="NM Fin Code"
                    value={6}
                    {...a11yProps(6)}
                    tabIndex={6}
                  />
                )}
                {nmArTabsInd === 1 &&
                  errorMessages?.filter((x) => {
                    return (
                      (x?.includes(START_QTR_UC) &&
                        x?.includes('NM Fin Code')) ||
                      (x?.includes(QUARTER_FORMAT_ERROR) &&
                        x?.includes('NM Fin Code')) ||
                      x?.includes(BUDGET_REF_REQ) ||
                      x?.includes(CLASS_FIELD_REQ)
                    );
                  }).length > 0 && <span className="tab-error">!</span>}
                {nmArTabsInd === 1 && (
                  <Tab
                    label="NM Account Number"
                    {...a11yProps(7)}
                    tabIndex={7}
                    value={7}
                  />
                )}
                {nmArTabsInd === 1 &&
                  errorMessages?.filter((x) => {
                    return (
                      (x?.includes(
                        'Start Quarter must be entered for the Row'
                      ) &&
                        x?.includes('NM Account Number')) ||
                      (x?.includes(QUARTER_FORMAT_ERROR) &&
                        x?.includes('NM Account Number')) ||
                      x?.includes(ACCOUNT_NUMBER_REQ) ||
                      x?.includes(FILE_TYPE_REQ)
                    );
                  }).length > 0 && <span className="tab-error">!</span>}
              </Tabs>
            </Box>
          </AppBar>
        )}
        {tabValue === 0 && (
          <TabPanel value={tabValue} index={0}>
            <DefaultAudit
              isReadOnly={isReadOnly}
              isEnabledByRole={isEnabledByRole}
              tabValue={tabValue}
              setErrorMessages={setErrorMessages}
              setUpdateDefaultAudit={setUpdateDefaultAudit}
              updateDefaultAudit={updateDefaultAudit}
              payload={payload}
              setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
              disabledSaveCancelBtn={disabledSaveCancelBtn}
            />
          </TabPanel>
        )}
        {tabValue === 1 && (
          <TabPanel value={tabValue} index={1}>
            <DefaultUnitType
              isReadOnly={isReadOnly}
              isEnabledByRole={isEnabledByRole}
              setErrorMessages={setErrorMessages}
              setUpdateDefaultTable={setUpdateDefaultTable}
              setCodeValueData={setCodeValueData}
              setDefCodeValueData={setDefCodeValueData}
              setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
              fullScreenView={fullScreenView}
              setFullScreenView={setFullScreenView}
              saveClicked ={saveClicked}
              setSaveClicked ={setSaveClicked}
              resetFlag = {resetDefaultUnitTypeFlag}
              setResetDefaultUnitTypeFlag ={setResetDefaultUnitTypeFlag}
              // updatDefaultTable={updatDefaultTable}
            />
          </TabPanel>
        )}
        {tabValue === 2 && (
          <TabPanel value={tabValue} index={2}>
            <GeneralSystemParameters
              isReadOnly={isReadOnly}
              isEnabledByRole={isEnabledByRole}
              setErrorMessages={setErrorMessages}
              setSystemParameterData={setSystemParameterData}
              setUpdateGenSysparameter={setUpdateGenSysparameter}
              setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
              disabledSaveCancelBtn={disabledSaveCancelBtn}
              setSuccessMessage={setSuccessMessage}
            />
          </TabPanel>
        )}
        {tabValue === 3 && (
          <TabPanel value={tabValue} index={3}>
            <DefaultSystemParameters
              isReadOnly={isReadOnly}
              isEnabledByRole={isEnabledByRole}
              setErrorMessages={setErrorMessages}
              setSystemParameterData={setSystemParameterData}
              setUpdateDefSysparameter={setUpdateDefSysparameter}
              setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
              disabledSaveCancelBtn={disabledSaveCancelBtn}
            />
          </TabPanel>
        )}
        {tabValue === 4 && (
          <TabPanel value={tabValue} index={4}>
            <Holiday
              isReadOnly={isReadOnly}
              isEnabledByRole={isEnabledByRole}
              setErrorMessages={setErrorMessages}
              setUpdateHoliday={setUpdateHoliday}
              fullScreenView={fullScreenView}
              setFullScreenView={setFullScreenView}
              setSuccessMessage={setSuccessMessage}
              setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
              disabledSaveCancelBtn={disabledSaveCancelBtn}
              spinnerLoader={spinnerLoader}
            />
          </TabPanel>
        )}

        {mdSpecTabInd === 1 && tabValue === 5 && (
          <TabPanel value={tabValue} index={5}>
            <MDspecteracode
              isReadOnly={isReadOnly}
              isEnabledByRole={isEnabledByRole}
              setErrorMessages={setErrorMessages}
              setUpdateMDSpecThera={setUpdateMDSpecThera}
              fullScreenView={fullScreenView}
              setSuccessMessage={setSuccessMessage}
              setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
              disabledSaveCancelBtn={disabledSaveCancelBtn}
              setFullScreenView={setFullScreenView}
            />
          </TabPanel>
        )}
        {nmArTabsInd === 1 && tabValue === 6 && (
          <TabPanel value={tabValue} index={6}>
            <NMFineCode
              isReadOnly={isReadOnly}
              isEnabledByRole={isEnabledByRole}
              setErrorMessages={setErrorMessages}
              setUpdateNMFinecode={setUpdateNMFincode}
              fullScreenView={fullScreenView}
              setFullScreenView={setFullScreenView}
              setSuccessMessage={setSuccessMessage}
              setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
              disabledSaveCancelBtn={disabledSaveCancelBtn}
            />
          </TabPanel>
        )}
        {nmArTabsInd === 1 && tabValue === 7 && (
          <TabPanel value={tabValue} index={7}>
            <NMAccountNumber
              isReadOnly={isReadOnly}
              isEnabledByRole={isEnabledByRole}
              setErrorMessages={setErrorMessages}
              setUpdateNMAccount={setUpdateNMAccount}
              fullScreenView={fullScreenView}
              setSuccessMessage={setSuccessMessage}
              setDisabledSaveCancelBtn={setDisabledSaveCancelBtn}
              disabledSaveCancelBtn={disabledSaveCancelBtn}
              setFullScreenView={setFullScreenView}
            />
          </TabPanel>
        )}
      </div>
    </>
  );
}

export default withRouter(BasicTabs);
